"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductColorModeState = void 0;

var React = __importStar(require("react"));

var react_hooks_1 = require("@bdl-cmn-shared-packages-npm/react-hooks");

var utils_1 = require("../utils");

function useSyncDocumentClassName(product, color) {
  React.useEffect(function () {
    requestAnimationFrame(function () {
      utils_1.syncDocumentBodyClassName(product, color === 'dark');
    });
  }, [color]);
}

function useSyncSystemColorMode(fn, enabled) {
  var callback = react_hooks_1.useLatestRef(fn);
  React.useEffect(function () {
    if (enabled) {
      var removeListener_1 = utils_1.addListener(callback.current);

      if (!!removeListener_1) {
        return function cleanup() {
          removeListener_1();
        };
      }
    }
  }, [callback, enabled]);
}

function useProductColorModeState(options) {
  var _a = react_hooks_1.useLocalStorage('luxembourg-stock-exchange-color-mode'),
      stored = _a[0],
      setLocalStorageValue = _a[1];

  var _b = React.useState(options.initialProductMode || 'luxse'),
      productMode = _b[0],
      setProductMode = _b[1];

  var _c = React.useState(function () {
    if (!!stored && (stored === 'light' || stored === 'dark')) {
      return stored;
    } else {
      if (options.useSystemColorMode) {
        return utils_1.getPrefersColorScheme();
      } else {
        return options.initialColorMode || 'light';
      }
    }
  }),
      colorMode = _c[0],
      setColorMode = _c[1];

  useSyncDocumentClassName(productMode, colorMode);
  useSyncSystemColorMode(setColorMode, options.useSystemColorMode);
  React.useEffect(function () {
    setLocalStorageValue(colorMode);
  }, [colorMode]);
  return [productMode, setProductMode, colorMode, setColorMode];
}

exports.useProductColorModeState = useProductColorModeState;